exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero-promo h1, .hero-promo h2, .hero-promo h3, .hero-promo h4, .hero-promo h5, .hero-promo h6 {\n  margin: 0 !important;\n}\n.hero-promo__content .ql-size-small {\n  font-size: 18px;\n}\n@media screen and (max-width: 767px) {\n.hero-promo__content .ql-size-small {\n    font-size: 14px;\n}\n}\n.hero-promo__content .ql-size-large {\n  font-size: 48px;\n}\n@media screen and (max-width: 767px) {\n.hero-promo__content .ql-size-large {\n    font-size: 32px;\n}\n}\n.hero-promo__content .ql-size-huge {\n  font-size: 65px;\n}\n@media screen and (max-width: 767px) {\n.hero-promo__content .ql-size-huge {\n    font-size: 46px;\n}\n}", ""]);

// exports
